<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="form-floating">
                    <input id="inputName" type="text" name="name" class="form-control"  v-model="plantType.name" @keyup.enter="submitForm" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                </div>
            </div>
        </div>
        
       
        
        <button class="btn btn-success mt-2 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'EditType',
    emits: ['closeModal'],
    props: {
        plantType: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            
        }
    },

    methods: {
        submitForm() {

            axios
                .patch(`/api/v1/planttypes/${this.plantType.id}/`, this.plantType)
                .then(response => {
                    
                    createToast({text: this.$t("plantType altered")
                   ,type: 'success'})

                   this.$emit('closeModal', 'edit', response.data)
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    }
}
</script>